import { ICanvasElement } from './canvas';

export enum EMarketingCenterFormats {
  instagramPost = 'instagram-post',
  instagramStory = 'instagram-story',
  facebookPost = 'facebook-post'
}

export interface IMarketingCenterFormat {
  key: EMarketingCenterFormats;
  name: string;
  elements: ICanvasElement[];
  renderScale?: number;
  canvas: {
    width: number | string;
    height: number | string;
  };
  asset: {
    width: number;
    height: number;
  };
  share: {
    width: number;
    height: number;
    icon: string;
  };
}
